// src/api/twynpopApi.js

// Base URL for FastAPI backend
const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://127.0.0.1:8000";

// Unified error handler
async function handleResponse(res) {
  if (!res.ok) {
    const text = await res.text();
    throw new Error(
      `API error ${res.status}: ${text || res.statusText || "Unknown error"}`
    );
  }
  return res.json();
}

// --------------------------------------------------------
// GET /clients/{client_id}/config
// --------------------------------------------------------
export async function getClientConfig(clientId) {
  const res = await fetch(`${API_BASE_URL}/clients/${clientId}/config`);
  return handleResponse(res);
}

// --------------------------------------------------------
// GET /statebundle/{state_fips}
// Returns { state_fips, bbox, geojson }
// --------------------------------------------------------
export async function getStateBundle(stateFips) {
  const res = await fetch(`${API_BASE_URL}/statebundle/${stateFips}`);
  return handleResponse(res);
}

// --------------------------------------------------------
// POST /scores
// --------------------------------------------------------
export async function getScores(payload) {
  const res = await fetch(`${API_BASE_URL}/scores`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  return handleResponse(res);
}

// --------------------------------------------------------
// GET /geojson/{state_fips}
// Fetch tract polygons from backend
// --------------------------------------------------------
export async function getStateGeoJSON(stateFips) {
  const res = await fetch(`${API_BASE_URL}/geojson/${stateFips}`);
  return handleResponse(res);
}

// --------------------------------------------------------
// NEW: GET /clients/{client_id}/overlay_meta/{state_fips}
// Returns { client_id, state_fips, available: { hardware_stores: true/false, ... } }
// --------------------------------------------------------
export async function getOverlayMeta(clientId, stateFips) {
  const res = await fetch(
    `${API_BASE_URL}/clients/${clientId}/overlay_meta/${stateFips}`
  );
  return handleResponse(res);
}

// --------------------------------------------------------
// NEW: GET /clients/{client_id}/overlays/{state_fips}
// Returns overlay GeoJSON objects (client/state-gated)
// Example returns { state_fips: "25", hardware_stores: { ...FeatureCollection... } }
// --------------------------------------------------------
export async function getOverlays(clientId, stateFips) {
  const res = await fetch(
    `${API_BASE_URL}/clients/${clientId}/overlays/${stateFips}`
  );
  return handleResponse(res);
}